import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=4b91d092&scoped=true&"
import script from "./Empty.vue?vue&type=script&lang=js&"
export * from "./Empty.vue?vue&type=script&lang=js&"
import style0 from "./Empty.vue?vue&type=style&index=0&id=4b91d092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91d092",
  null
  
)

export default component.exports